import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { GetBasicReservationInformationStoreService } from '@lib/services';
import { CheckinBaseClass } from '../../components';
import { GetBasicReservationInformationResponseData } from 'src/sdk-amcmember';

@Injectable()
export class CheckinPassengerInputBasicReservationInformationService extends CheckinBaseClass {
  /** 予約基本情報取得APIレスポンス正常通知イベント */
  isGetBasicReservationInformationSuccess$ = new Subject<GetBasicReservationInformationResponseData | void>();

  constructor(private _getBasicReservationInformationStoreService: GetBasicReservationInformationStoreService) {
    super();

    this.watchGetBasicReservationInformationSuccess();
    this.watchGetBasicReservationInformationFailure();
  }

  override destroy(): void {}

  /**
   * 予約基本情報取得APIリクエスト
   */
  getBasicReservationInformation(): void {
    this._getBasicReservationInformationStoreService.setGetBasicReservationInformationFromApi({});
  }

  /**
   * 予約基本情報取得APIレスポンス正常取得
   */
  private watchGetBasicReservationInformationSuccess(): void {
    this.subscribeService(
      this._getBasicReservationInformationStoreService.getGetBasicReservationInformation$().pipe(
        pairwise(),
        filter(([prev, curr]) => prev.isPending === true && curr.isPending === false && curr.isFailure === false),
        map(([_, cur]) => cur)
      ),
      (state) => {
        this.isGetBasicReservationInformationSuccess$.next(state.data);
      }
    );
  }

  /**
   * 予約基本情報取得APIレスポンス異常取得
   */
  private watchGetBasicReservationInformationFailure(): void {
    this.subscribeService(
      this._getBasicReservationInformationStoreService.getGetBasicReservationInformation$().pipe(
        pairwise(),
        filter(([prev, curr]) => prev.isPending === true && curr.isPending === false && curr.isFailure === true)
      ),
      () => {
        this.isGetBasicReservationInformationSuccess$.next();
      }
    );
  }
}
